import React, {useEffect, useRef, useState} from 'react';
import {useTranslation} from 'react-i18next';
import {Animated, Keyboard, Text, TouchableOpacity, View} from 'react-native';
import {useMutation} from 'react-query';
import {useDispatch, useSelector} from 'react-redux';
import {showAlert} from '../../../../../actions/AlertActions';
import {showSheet} from '../../../../../actions/SheetActions';
import FabBackButton from '../../../../../components/fab-back-button/FabBackButton.componet';
import FieldHeader from '../../../../../components/fields/field-header/FieldHeader.component';
import ValidLabelField from '../../../../../components/fields/valid-label-field/ValidLabelField.component';
import PrimaryButton from '../../../../../components/primary-button/PrimaryButton.component';
import {
  useRequestMessage,
  useRequestSuggestion,
  useReturnDepositeMessage,
} from '../../../../../hooks/useValidations';
import {useApi} from '../../../../../providers/ApiProvider';
import {selectrootsheettype} from '../../../../../selectors/SheetSelector';
import styles from './SupportMessageSheet.style';
import {useHistory} from '../../../../../imports/Router';
import {isWeb, windowHeight} from '../../../../../constants';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
let suggestionHook;
let otherHook;
let returnHook;

export default function SupportMessageSheet(props) {
  const {t} = useTranslation();
  const dispatch = useDispatch();
  const history = useHistory();
  const {api} = useApi();
  const insets = useSafeAreaInsets();
  const bottomInset = isWeb ? 0 : Math.max(insets.bottom - 10, 16);
  const [keyboardVisible, setKeyboardVisible] = useState(0);
  const translateY = useRef(new Animated.Value(421)).current;
  const [validationEnabled, setValidationEnabled] = useState(false);
  const {sheetId, sheetProps} = useSelector(state =>
    selectrootsheettype(state),
  );
  const {header, label, placeholder, successProps} = sheetProps;
  const shabaNumber = sheetProps?.shabaNumber ?? '';
  const id = sheetProps?.id;
  const title = sheetProps?.title;

  useEffect(() => {
    switch (sheetId) {
      case 'supportMessage':
        Keyboard.dismiss();
        Animated.timing(translateY, {
          toValue: 0,
          duration: 400,
          useNativeDriver: true,
        }).start();
        break;
      default:
        closeHandler();
        break;
    }
  }, [sheetId]);

  const closeHandler = () => {
    Animated.timing(translateY, {
      toValue: 421,
      duration: 400,
      useNativeDriver: true,
    }).start();
    setTimeout(() => {
      dispatch(showSheet({sheetId: ''}));
    }, 400);
  };
  if (id === 7) {
    suggestionHook = useRequestSuggestion(!validationEnabled);
  } else if (id === 5) {
    returnHook = useReturnDepositeMessage(!validationEnabled);
  } else {
    otherHook = useRequestMessage(!validationEnabled);
  }
  const message =
    id === 7
      ? suggestionHook.value
      : id === 5
      ? returnHook.value
      : otherHook.value;
  const setMessage =
    id === 7
      ? suggestionHook.setValue
      : id === 5
      ? returnHook.setValue
      : otherHook.setValue;
  const messageValidation =
    id === 7
      ? suggestionHook.result
      : id === 5
      ? returnHook.result
      : otherHook.result;
  const messageCheckError =
    id === 7
      ? suggestionHook.checkError
      : id === 5
      ? returnHook.checkError
      : otherHook.checkError;

  function onSubmit() {
    if (id === 5) {
      // dispatch(
      //   showSheet({
      //     sheetId: 'confirmReturnDeposit',
      //     sheetProps: {
      //       header: 'confirmation_deposit_return_request',
      //       label: 'write_reason_for_request',
      //       // shabaNumber: sheba.replaceAll(' ', ''),
      //       title: 'درخواست بازگشت سپرده',
      //       id: '7',
      //       placeholder: 'write_description_here',
      //       successProps: {
      //         title: 'your_request_successfully_registered',
      //         description: 'after_ten_working_days',
      //       },
      //     },
      //   }),
      // );
      // postFeedbackMutation.mutate({
      //   description: `${shabaNumber}|${message}`,
      //   title,
      //   feedback_type_id: id
      // });
    } else {
      Keyboard.dismiss();
      if (messageCheckError()) {
        setValidationEnabled(true);
      } else {
        postFeedbackMutation.mutate({
          description: message,
          title,
          feedback_type_id: id,
        });
      }
    }
  }

  const postFeedbackMutation = useMutation({
    mutationFn: async body => {
      return api.postFeedback(body);
    },
    onSuccess: res => {
      console.log('res', res);
      closeHandler();
      setTimeout(() => {
        history.push({
          pathname: '/main/dashboard/send-message-success',
          state: {
            title: successProps?.title ?? '',
            description: successProps?.description ?? '',
          },
        });
      }, 400);
    },
    onError: err => {
      console.log('err', err);
      if (err.response.data.Result === 'Error_Duplicate') {
        dispatch(
          showAlert({
            id: 'AlertBox',
            modalProps: {
              icon: 'redExclamation',
              title: t('duplicate'),
            },
          }),
        );
      } else {
        dispatch(
          showAlert({
            id: 'AlertBox',
            modalProps: {
              icon: 'redExclamation',
              title: t('Error_UnknownError'),
            },
          }),
        );
      }
    },
  });

  function webkeyboard(event) {
    if (event.currentTarget.height != windowHeight) {
      setKeyboardVisible(true);
    } else {
      setKeyboardVisible(false);
    }
  }

  if (isWeb) {
    window.visualViewport.addEventListener('resize', event =>
      webkeyboard(event),
    );
    useEffect(() => {
      return () => window.removeEventListener('resize', webkeyboard);
    }, []);
  }

  useEffect(() => {
    if (keyboardVisible) {
      Animated.timing(translateY, {
        toValue: -80,
        duration: 10,
        useNativeDriver: true,
      }).start();
    } else {
      Animated.timing(translateY, {
        toValue: 0,
        duration: 10,
        useNativeDriver: true,
      }).start();
    }
  }, [keyboardVisible]);

  return (
    <>
      <TouchableOpacity
        activeOpacity={1}
        onPress={closeHandler}
        style={styles.container}
      />
      {isWeb && keyboardVisible ? (
        <View style={styles.inputBackGround} />
      ) : null}
      <Animated.View
        style={[{transform: [{translateY: translateY}]}, styles.content]}>
        <View style={styles.indicator} />
        <View style={styles.header}>
          <FabBackButton
            container_style={[styles.backButton]}
            onPress={closeHandler}
            icon={'closeIcon'}
          />
          <Text style={styles.screenTitle}>{t(header)}</Text>
        </View>
        <FieldHeader text={t(label)} containerStyle={styles.title} />
        <ValidLabelField
          containerStyle={styles.inputContainer}
          inputAreaStyle={{...styles.inputArea}}
          inputStyle={{...styles.input}}
          onChangeText={setMessage}
          multiline={true}
          label={''}
          autoFocus
          value={message}
          isError={validationEnabled && messageCheckError()}
          errorText={messageValidation.error}
          placeholder={t(placeholder)}
          {...props}
        />
        <PrimaryButton
          title={t('request_registration')}
          containerStyle={[styles.button , { marginBottom: bottomInset + 20}]}
          onPress={onSubmit}
          isLoading={postFeedbackMutation.isLoading}
        />
      </Animated.View>
    </>
  );
}
